import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import ToastMe from '@/components/ui/ToastMe';
import Swal from 'sweetalert2';
import { getOfferItemService, deleteOfferItemService } from '@/services/OfferItemServices';
import AddEditItemModel from './AddEditItemModel';
import DataTableItem from './DataTableItem';

const ItemsTabs = ({ dataSource }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [editDataId, setEditDataId] = useState('');
    const [offerItemDataSource, setOfferItemDataSource] = useState([]);
    const [offerItemTotal, setOfferItemTotal] = useState(0);
    const [openOfferItemModel, setOpenOfferItemModel] = useState(false);
    const [offerItemFilter, setOfferItemFilter] = useState({
        search: '',
        page: 1,
        limit: 10,
        extra_filter: {},
    });

    useEffect(() => {
        if (dataSource?._id && dataSource?._id != '') {
            getRetryData();
        }
    }, [dataSource?._id]);

    const tableItmAddonsColumn = [
        { name: 'Name', isIncludePrint: true },
        { name: 'Price', isIncludePrint: true },
        { name: 'Status', isIncludePrint: true },
        { name: 'Action', isIncludePrint: false },
    ];

    const onChangeOfferItemFilter = (name, value) => {
        setOfferItemFilter({ ...offerItemFilter, [name]: value });
    };

    const getRetryData = () => {
        getItemAttributesData(dataSource?._id);
    };

    const getItemAttributesData = (offerId) => {
        setIsLoading(true);
        setOfferItemFilter({ ...offerItemFilter, extra_filter: { offer_id: offerId } });

        dispatch(getOfferItemService({ ...offerItemFilter, extra_filter: { offer_id: offerId } }))
            .then((res) => {
                setOfferItemDataSource(res?.data?.data?.data);
                setOfferItemTotal(res?.data?.data?.total);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const handleEditOpen = (editId) => {
        if (editId && editId != '') {
            setEditDataId(editId);
        } else {
            setEditDataId('');
        }
        setOpenOfferItemModel(true);
    };

    const deleteRecord = (deleteId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                dispatch(deleteOfferItemService(deleteId))
                    .then((res) => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'Your record has been deleted.',
                            icon: 'success',
                        });
                        getItemAttributesData(dataSource?._id);
                        setIsLoading(false);
                    })
                    .catch(({ message, errorData, statusCode }) => {
                        validationErrors(errorData, message);
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <button type="button" onClick={() => setOpenOfferItemModel(true)} className={'db-btn h-[37px] text-white bg-primary mb-5'}>
                <i className={'lab lab-add-circle-line'}></i>
                Add Item
            </button>

            <DataTableItem
                isLoading={isLoading}
                tableColumn={tableItmAddonsColumn}
                dataSource={offerItemDataSource}
                totalRecord={offerItemTotal}
                dataFilter={{
                    search: '',
                    page: 1,
                    limit: 100,
                    extra_filter: { offer_id: dataSource?._id },
                }}
                handleEditOpen={handleEditOpen}
                deleteRecord={deleteRecord}
                onChangePage={onChangeOfferItemFilter}
            />
            <AddEditItemModel modelTitle={'Item'} getTableData={getRetryData} openModel={openOfferItemModel} setOpenModel={setOpenOfferItemModel} editDataId={editDataId} offerId={dataSource?._id} />
        </>
    );
};

export default ItemsTabs;
